module.exports = __webpack_public_path__ + "img/人参叶.ac470470.jpg";